import { pods_carousels, initPodsCarousel } from './carousel';

/**
 * Index of a pod among the *real* slides, snapped down to the start of its
 * group. Flickity did this via `slides.length / cells.length` — a ratio that
 * only existed because `groupCells` collapsed N cells into one slide. The
 * in-house carousel indexes by slide, so the equivalent is to floor the pod's
 * index onto a group boundary. Clones (loop mode) are filtered out first, or
 * the index is off by the number of leading clones.
 */
const groupedIndexOf = (carouselElement, pod, instance) => {
  if (!carouselElement || !pod) return -1;

  const track = carouselElement.querySelector('[data-pods-carousel-track]') || pod.parentNode;
  const realSlides = Array.from(track.children).filter((child) => !child.hasAttribute('data-clone'));
  const index = realSlides.indexOf(pod);
  if (index < 0) return -1;

  const group = Math.max(1, (instance && instance.slidesPerGroup) || 1);
  return Math.floor(index / group) * group;
};

export default function () {
  document.addEventListener('shopify:section:load', (e) => {
    const id = `PodsCarousel${e.detail.sectionId}`;
    const carouselElement = document.getElementById(id);
    // Is this a carousel?
    if (carouselElement) {
      let index = 0;

      // Has this carousel already been initialized? Destroy it if so...
      if (pods_carousels[id]) {
        // Save the current slide's index so we can immediately reinitialize at the same slide later
        index = pods_carousels[id].selectedIndex;
        // Destroy the existing one since it exists
        pods_carousels[id].destroy();
        delete pods_carousels[id];
      }

      // Reinitialize the carousel with new options
      initPodsCarousel(carouselElement, index);
    }
  });

  document.addEventListener('shopify:block:select', (e) => {
    const id = `PodsCarousel${e.detail.sectionId}`;
    const carouselElement = document.getElementById(id);
    // Not every pods section has a live carousel — `all_pods_visible` and the
    // empty-track bail both leave the map entry unset.
    const instance = pods_carousels[id];
    if (!carouselElement || !instance) return;

    // Navigate to the correct slide and pause autoplay
    const blockElement = document.getElementById(`Pod${e.detail.blockId}`);
    const index = groupedIndexOf(carouselElement, blockElement, instance);
    if (index < 0) return;

    instance.select(index);
    instance.pausePlayer();
  });

  document.addEventListener('shopify:block:deselect', (e) => {
    const id = `PodsCarousel${e.detail.sectionId}`;
    const instance = pods_carousels[id];
    // Is this a carousel?
    if (instance) {
      // Unpause autoplay
      instance.unpausePlayer();
    }
  });
}
